import React from 'react'
import {dataSource} from './constants.js'
import axios from 'axios'
import * as NavLinks from './NavLinks'
import './styles/Project.css'
import Loader from './Loader'
import Credits from './Credits'
import Slider from './Slider'
import { animateScroll, Element } from 'react-scroll'

class Project extends React.Component{

	constructor(props) {
		super(props);

		this.state={
			entry:{
				there: false,
				data: {},
			},
		}

		this.getProjectData = this.getProjectData.bind(this)
		this.renderProjectHeader = this.renderProjectHeader.bind(this)
		this.renderMobileProjectHeader = this.renderMobileProjectHeader.bind(this)

	}



	componentDidMount() {
		this.getProjectData()
	}



	render(){

		const {project} = this.props
		const { innerHeight, media  } = this.props

			return(
				<div className="Project with-footer" style={{minHeight: innerHeight}}>
					<div>
						{media !== 'MOBILE' ? this.renderProjectHeader() : this.renderMobileProjectHeader() }

						<div className="Slideshow" >
							<Slider 
								images={project.projektbilder} 
								innerHeight={innerHeight}
								media={media}
								thumbnailToggle={this.thumbnailToggle}
							/>
						</div>
							<Element name="description" className="BeschreibungContainer padding">
								<div className="desktop-push-half tablet-push-half">
									<h1 className="small-type">
										<strong>{project.title}</strong>
									</h1>

									{ project.beschreibung ? 
										<div className="Beschreibung small-type padding-right" dangerouslySetInnerHTML={{__html: project.beschreibung}}/> 
									: null }
									{ project.zusatzinformationen ? 
										<div className="Zusatzinformationen small-type grey-type padding-right" dangerouslySetInnerHTML={{__html: project.zusatzinformationen}}/> 
									: null }
								</div>
							</Element>
							<div className="padding">
								<div className="desktop-push-half tablet-push-half mobile-align-center">
									{NavLinks.BackLink}
								</div>
					        </div>
							<Credits />
					</div>

				</div>
			)
	}

/*===============================
=            Renders            =
===============================*/
	renderProjectHeader(){
		const {project} = this.props
		return(
		<div className="ProjectTitle padding-vertical ">
		    <div className="row">
	            <div className="col col-6">
					<h1>
						{project.title}
					</h1>
	            </div>
	            <div className="col col-6">
	                {NavLinks.BackLink}

	            </div>
	        </div>
		</div>
		)
	}
	renderMobileProjectHeader(){
		const {project} = this.props
		return(
			<div className=" ProjectTitle padding">
				<div className="float-container">
					<div className="float-right">
		                {NavLinks.BackLink}
					</div>
					<div className="float-left">
						<h1>
							{project.title}
						</h1>
					</div>
				</div>
			</div>
		)
	}


/*=====  End of Renders  ======*/



	getProjectData(){
		const { location } = this.props;
	}

}

export default Project


// WEBPACK FOOTER //
// ./src/Project.js